import { FaClock, FaUserPlus } from 'react-icons/fa';

export const reportOptions = [
  {
    key: 'practitioner_hours',
    name: 'Practitioner Work Hours Report',
    icon: <FaClock />,
    description: 'Shows detailed working hours logged by each practitioner within the selected date range.',
  },
  {
    key: 'new_patients_without_appointments',
    name: 'New Patients Without Appointments',
    icon: <FaUserPlus />,
    description: 'Lists patients who registered but haven’t booked an appointment yet.',
  }
];
